const isRunningAsPwa = window.matchMedia("(display-mode: standalone)").matches;
export { isRunningAsPwa };
